module.exports = __webpack_public_path__ + "static/so-7b06b97c41b0a8f6d0d4048204f775c5.gif";